import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { GridBox, Grid, TableHead, TableHeadRow, TableHeaders } from 'libs/ui';
import { Signal } from '../signal/signal';

class SignalsHistoryGrid extends Component {
  constructor(props) {
    super(props);
    this.box = React.createRef();
    this.grid = React.createRef();
  }

  /**
   * get signal table rows
   * @returns []
   */
  getSignalsList = () => {
    const { signals, target } = this.props;
    let out = [];
    if (signals) {
      out = signals.map((el, idx) => {
        const other = {};
        if (!target) {
          other.view = 'full';
        }
        return <Signal key={idx} {...el} {...other} />;
      });
    }
    return out;
  };

  scrollListner = () => {
    if (this.box.current.scrollTop + this.box.current.clientHeight + 50 > this.grid.current.clientHeight) {
      this.props.addEvents(true);
    }
  };

  render() {
    const { t } = this.props;
    const { target } = this.props;
    const signals = this.getSignalsList();

    return (
      <GridBox className={this.props.loading ? 'loading' : ''} ref={this.box} $maxHeight={'445px'} onScroll={this.scrollListner}>
        <Grid ref={this.grid}>
          <TableHead>
            <TableHeadRow>
              <TableHeaders width="210">{t('windows.Начало')}</TableHeaders>
              {!target && <TableHeaders width="180">{t('windows.Источник')}</TableHeaders>}
              <TableHeaders>{t('windows.Описание сигнала')}</TableHeaders>
            </TableHeadRow>
          </TableHead>
          <tbody>{signals}</tbody>
        </Grid>
      </GridBox>
    );
  }
}

export default withTranslation()(SignalsHistoryGrid);
